const CONTACT_API = 'https://api.punch-in.co.uk/contact';

export const submitContactRequest = ({ name, email, phone, message }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', { send_to: 'AW-1061344408/pCV7CJiHhsMDEJipi_oD' });
  }

  return fetch(CONTACT_API, {
    method: 'POST',
    body: JSON.stringify({ name, email, phone, message }),
    mode: 'cors',
    headers: { 'content-type': 'application/json' },
    redirect: 'follow',
  }).then((res) => {
    if (res.status > 199 && res.status < 300) {
      return res.json();
    }
    throw new Error('unexpected');
  });
};
